import withConfigTransport from '../../../services/config-transport/withConfigTransport'
import VaFileUploadUndo from './VaFileUploadUndo.vue'

export default withConfigTransport(VaFileUploadUndo)
